// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 商品分类 -- 列表
 */
export function getCategory(data?: any) {
    return request({
        url: 'store/category/list',
        method: 'get',
        params: data,
    });
}

/**
 * @description 商品列表 -- 列表
 */
export function getProduct(data: any) {
    return request({
        url: 'diy/product/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 首页diy -- 保存
 */
export function diySave(id: number | string, data: any) {
    return request({
        url: `diy/create/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 店铺装修 -- 列表
 */
export function diyList(data: any) {
    return request({
        url: 'diy/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 获取diy数据
 */
export function diyGetInfo(id: number | string) {
    return request({
        url: `diy/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description diy列表数据 -- 删除
 */
export function diyDel(id: number | string, data: any) {
    return request({
        url: `diy/delete/${id}`,
        method: 'delete',
        data,
    });
}

/**
 * @description diy列表数据 -- 使用diy模板
 */
export function setStatus(id: number | string) {
    return request({
        url: `diy/status/${id}`,
        method: 'post',
    });
}

/**
 * @description diy -- 恢复模板初始数据
 */
export function recovery(id: number | string) {
    return request({
        url: `diy/recovery/${id}`,
        method: 'get',
    });
}

/**
 * @description diy -- 设置初始数据
 */
export function setDefault(id: number | string) {
    return request({
        url: `diy/set_default_data/${id}`,
        method: 'post',
    });
}

/**
 * @description 获取分类
 */
export function categoryList() {
    return request({
        url: '/cms/category_list',
        method: 'get',
    });
}

/**
 * @description 获取链接列表
 */
export function getUrl(data: any) {
    return request({
        url: 'diy/link/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 获取链接列表
 */
export function getLinkList(data: any) {
    return request({
        url: 'diy/link/list',
        method: 'get',
        params: data,
    });
}

/**
 * @description 获取产品一或二级分类
 */
export function getByCategory(data: any) {
    return request({
        url: 'diy/get_by_category',
        method: 'get',
        params: data,
    });
}

/**
 * @description 使用diy模板(判断是否显示周边门店列表)
 */
export function storeStatus() {
    return request({
        url: 'diy/get_store_status',
        method: 'get',
    });
}

/**
 * @description 使用diy模板(活动商品)
 */
export function getGroomList(type: string, data: any) {
    return request({
        url: `diy/groom_list/${type}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 小程序 -- 二维码；
 */
export function getRoutineCode(id: number | string) {
    return request({
        url: `diy/get_routine_code/${id}`,
        method: 'get',
    });
}

/**
 * @description 个人中心-获取信息；
 */
export function getMember() {
    return request({
        url: 'diy/user_index',
        method: 'get',
    });
}

/**
 * @description 个人中心-提交信息；
 */
export function memberSave(data: any) {
    return request({
        url: 'diy/user_index',
        method: 'post',
        data,
    });
}

/**
 * @description 页面链接-获取分类；
 */
export function pageCategory(data: any) {
    return request({
        url: 'diy/categroy/options',
        method: 'get',
        params: data,
    });
}

/**
 * @description 页面链接-获取链接；
 */
export function pageLink(id: number | string, data: any) {
    return request({
        url: `diy/link/getLinks/${id}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 页面链接-获取链接；
 */
export function getPageLinks(data: any) {
    return request({
        url: 'diy/link/list',
        method: 'get',
        params: data,
    });
}

/**
 * @description 页面链接-自定义链接提交；
 */
export function saveLink(data: any, id: number | string) {
    return request({
        url: `diy/save_link/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 页面链接-获取链接；
 */
export function getPageUrl() {
    return request({
        url: 'diy/show',
        method: 'get',
    });
}

/**
 * @description diy-添加平台分类
 */
export function addPlantCategory() {
    return request({
        url: 'diy/categroy/form',
        method: 'get',
    });
}

/**
 * @description diy-编辑平台分类
 */
export function editPlantCategory(id: number | string) {
    return request({
        url: `diy/categroy/${id}/form`,
        method: 'get',
    });
}

/**
 * @description diy-平台分类列表
 */
export function plantCategoryList(data: any) {
    return request({
        url: 'diy/categroy/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description diy-平台分类修改状态
 */
export function plantCategoryStatus(id: number | string, status: number) {
    return request({
        url: `diy/categroy/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description diy-删除平台分类
 */
export function deletePlantCategory(id: number | string) {
    return request({
        url: `diy/categroy/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description diy-添加店铺分类
 */
export function addMerCategory() {
    return request({
        url: 'diy/mer_categroy/form',
        method: 'get',
    });
}

/**
 * @description diy-编辑店铺分类
 */
export function editMerCategory(id: number | string) {
    return request({
        url: `diy/mer_categroy/${id}/form`,
        method: 'get',
    });
}

/**
 * @description diy-店铺分类列表
 */
export function merCategoryList(data: any) {
    return request({
        url: 'diy/mer_categroy/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description diy-店铺分类修改状态
 */
export function merCategoryStatus(id: number | string, status: number) {
    return request({
        url: `diy/mer_categroy/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description diy-删除店铺分类
 */
export function deleteMerCategory(id: number | string) {
    return request({
        url: `diy/mer_categroy/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description diy-添加平台链接
 */
export function addPlantLink() {
    return request({
        url: 'diy/link/form',
        method: 'get',
    });
}

/**
 * @description diy-编辑平台链接
 */
export function editPlantLink(id: number | string) {
    return request({
        url: `diy/link/${id}/form`,
        method: 'get',
    });
}

/**
 * @description diy-删除平台链接
 */
export function deletePlantLink(id: number | string) {
    return request({
        url: `diy/link/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description diy-平台链接列表
 */
export function plantLinkList(data: any) {
    return request({
        url: 'diy/link/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description diy-平台页面链接状态
 */
export function plantLinkStatus(id: number | string, status: number) {
    return request({
        url: `diy/link/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description diy-添加店铺链接
 */
export function addMerLink() {
    return request({
        url: 'diy/mer_link/form',
        method: 'get',
    });
}

/**
 * @description diy-编辑店铺链接
 */
export function editMerLink(id: number | string) {
    return request({
        url: `diy/mer_link/${id}/form`,
        method: 'get',
    });
}

/**
 * @description diy-删除店铺链接
 */
export function deleteMerLink(id: number | string) {
    return request({
        url: `diy/mer_link/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description diy-店铺链接列表
 */
export function merLinkList(data: any) {
    return request({
        url: 'diy/mer_link/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description diy-店铺页面链接状态
 */
export function merLinkStatus(id: number | string, status: number) {
    return request({
        url: `diy/mer_link/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 可视化-店铺街获取数据
 */
export function getColorChange() {
    return request({
        url: 'diy/store_street',
        method: 'get',
    });
}

/**
 * @description 可视化-店铺街提交数据
 */
export function colorChange(data: any) {
    return request({
        url: 'diy/store_street',
        method: 'post',
        data,
    });
}

/**
 * @description 可视化-商城首页复制
 */
export function diyCopy(id: number | string) {
    return request({
        url: `diy/copy/${id}`,
        method: 'get',
    });
}

/**
 * @description 微页面 -- 保存
 */
export function microSave(id: number | string, data: any) {
    return request({
        url: `micro/create/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 微页面 -- 列表
 */
export function microList(data: any) {
    return request({
        url: 'micro/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 获取微页面数据
 */
export function microGetInfo(id: number | string) {
    return request({
        url: `micro/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 微页面列表数据 -- 删除
 */
export function microDel(id: number | string, data: any) {
    return request({
        url: `micro/delete/${id}`,
        method: 'delete',
        data,
    });
}

/**
 * @description diy-获取微页面链接
 */
export function getPageLink() {
    return request({
        url: 'diy/select',
        method: 'get',
    });
}

/**
 * @description 店铺首页diy -- 列表
 */
export function merchantDiyList(data: any) {
    return request({
        url: 'mer_diy/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺diy模板 -- 删除
 */
export function merchantDiyDel(id: number | string, data: any) {
    return request({
        url: `mer_diy/delete/${id}`,
        method: 'delete',
        data,
    });
}

/**
 * @description 店铺diy模板-复制
 */
export function merchantDiyCopy(id: number | string) {
    return request({
        url: `mer_diy/copy/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺diy模板 -- 保存
 */
export function merchantDiySave(id: number | string, data: any) {
    return request({
        url: `mer_diy/create/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 店铺diy模板 -- 详情
 */
export function merchantDiyInfo(id: number | string) {
    return request({
        url: `mer_diy/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺diy模板 -- 适用范围详情
 */
export function getMerchantScope(id: number | string) {
    return request({
        url: `mer_diy/scope/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺diy模板 -- 设置适用范围
 */
export function setMerchantScope(id: number | string, data: any) {
    return request({
        url: `mer_diy/scope/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 商品详情diy -- 保存
 */
export function saveProductDetail(data: any) {
    return request({
        url: 'diy/save_product_detail',
        method: 'post',
        data,
    });
}

/**
 * @description 商品详情diy -- 详情
 */
export function getProductDetail() {
    return request({
        url: 'diy/get_product_detail',
        method: 'get',
    });
}


/**
 * @description 悬浮按钮diy -- 详情
 */
export function getSuspendedDiy() {
    return request({
        url: 'diy/fab/info',
        method: 'get',
    });
}
/**
 * @description 悬浮按钮diy -- 保存
 */
export function saveSuspendedDiy(id:number,data:any) {
    return request({
        url: `diy/fab/create/${id}`,
        method: 'post',
        data,
    });
}
/**
 * @description 商品分类diy -- 详情
 */
export function getCategoryApi() {
    return request({
        url: 'diy/productCategory/info',
        method: 'get',
    });
}
/**
 * @description 商品分类diy -- 保存
 */
export function saveCategoryApi(id:number,data:any) {
    return request({
        url: `diy/productCategory/create/${id}`,
        method: 'post',
        data,
    });
}
